import { render } from "./CompanyLogo.vue?vue&type=template&id=432ff25d&scoped=true&ts=true"
import script from "./CompanyLogo.vue?vue&type=script&lang=ts"
export * from "./CompanyLogo.vue?vue&type=script&lang=ts"

import "./CompanyLogo.vue?vue&type=style&index=0&id=432ff25d&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-432ff25d"]])

export default __exports__